import { consoleRequest } from '@/console/api/http'
import { ManualRedispatchRequest, ManualRedispatchResponse } from '@/console/api/types'

/**
 * LOGISPRD-12506 Task 14 — F-OPT 재발사 API(핸드오프 §4.2, `@devOpsGate`). 규약 B — 성공은 raw
 * DTO(`ManualRedispatchResponse`), 실패만 `ApiResponseV2`(`toPanelError` 가 공통으로 읽는다).
 *
 * **동기 호출·최대 5분** 이 결정적 함정이다:
 *  - `src/utils/request.ts` 의 `http = axios.create({ timeout: 100000 })` — 전역 timeout 이 100초라
 *    5분보다 훨씬 짧다. 이 호출만 5분(300000ms)으로 올린다. 전역 설정(`request.ts`)은 어드민 공용이라
 *    건드리지 않고, `consoleRequest.post` 의 `extraConfig` 로 이 호출에만 얹는다(`api/http.ts` 참고).
 *  - **자동 재시도 절대 금지.** 재시도하면 실제 주문이 중복 재발사된다. 이 함수는 axios 재시도
 *    인터셉터를 쓰지 않고, 단발 `Promise` 하나로 끝난다 — 실패해도 이 함수가 알아서 다시 부르지
 *    않는다(재시도는 오직 사용자가 화면에서 다시 눌렀을 때만 일어난다).
 */
const BASE = '/api/v1/workflow/outbound-dispatch/manual'

/** 5분 — 핸드오프 §4.2 "동기, 최대 5분". 전역 axios timeout(100000ms)보다 길게 이 호출에만 건다. */
export const MANUAL_REDISPATCH_TIMEOUT_MS = 5 * 60 * 1000

export const requestManualRedispatch = (request: ManualRedispatchRequest): Promise<ManualRedispatchResponse> =>
  consoleRequest.post<ManualRedispatchResponse, ManualRedispatchRequest>(BASE, request, { timeout: MANUAL_REDISPATCH_TIMEOUT_MS })
